module.exports = __webpack_public_path__ + "img/TimeRange.f4a9c008.svg";